import React from "react";
import { Route, Routes } from "react-router-dom";
import { LayoutApp } from "../components";
import ProfileCompletionContainer from "../shared/containers/ProfileCompletionContainer/ProfileCompletionContainer";
import { PAGES_PATH } from "./params";
import AddPhoneNoContainer from "../pages/Onboarding/containers/AddPhoneNoContainer/AddPhoneNoContainer";
import RequireCompleteProfile from "./RequireCompleteProfile";
import RedirectCompleteProfile from "./RedirectCompleteProfile";

const PrivateRoutesContainer = () => {
  return (
    <Routes>
      <Route element={<RedirectCompleteProfile />}>
        <Route path={PAGES_PATH.PROFILE_COMPLETION} element={<ProfileCompletionContainer />} />
        <Route path={PAGES_PATH.ADD_PHONE_NUMBER} element={<AddPhoneNoContainer />} />
      </Route>

      <Route element={<RequireCompleteProfile />}>
        <Route path="*" element={<LayoutApp />} />
      </Route>
    </Routes>
  );
};

export default PrivateRoutesContainer;
